import {Component, Injector} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ShortLinkConfig} from '@components/form-field/form-date-range/date-range-short-link';
import {JournalDownloadButtonService} from '../journal-download-button/journal-download-button.service';
import {ConclusionJournalService} from '../../services/conclusion-journal.service';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {SelectValuesApiService} from '@api/select-values.api.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';

@Component({
    selector: 'app-journal-download-form',
    templateUrl: './journal-download-form.component.html',
    styleUrls: ['./journal-download-form.component.scss'],
    providers: []
})
export class JournalDownloadFormComponent extends FrontendFormComponent {
    constructor(
        injector: Injector,
        public formService: ConclusionJournalService,
        public service: JournalDownloadButtonService,
        private ajaxDownloadService: AjaxDownloadService,
        private selectValuesService: SelectValuesApiService,
    ) {
        super(injector);
    }

    get saveUrl(): string {
        return this.formService.validateUrl;
    }

    dateLinksConfig: ShortLinkConfig[] = [
        {label: 'Неделя', daysShift: -7},
        {label: 'Месяц', monthsShift: -1},
        {label: 'Квартал', monthsShift: -3},
        {label: 'Год', monthsShift: -12},
    ];

    form = this._fb.group({
        working_object_id: [''],
        tc_im_method_id: [''],
        conclusion_date_from: [''],
        conclusion_date_to: [''],
    });

    public workingObjects: SelectValueInterface[];
    public industryMethods: SelectValueInterface[];

    init(): void {

        const allMethods: SelectValueInterface[] = [{id: '', title: 'Все методы'}];
        const allObjects: SelectValueInterface[] = [{id: '', title: 'Все объекты'}];

        this.selectValuesService.get({
            url: this.selectValuesService.methodsForConclusionJournal
        }).subscribe((industryMethods: SelectValueInterface[]) => {
            this.industryMethods = allMethods.concat(industryMethods || []);
        }, () => {
            this.industryMethods = allMethods;
        });

        this.selectValuesService.get({
            url: this.selectValuesService.workingObjectForConclusionJournal
        }).subscribe((workingObjects: SelectValueInterface[]) => {
            this.workingObjects = allObjects.concat(workingObjects || []);
        }, () => {
            this.workingObjects = allObjects;
        });
    }

    cancel() {
        this.service.cancel$.next();
    }

    afterSave(data?): void {
        this.isPending = false;
        this.service.formDownloadQueue$ = this.ajaxDownloadService.do({
            url: this.formService.generateUrl,
            method: 'post',
            taskName: 'Журнал заключений',
            data: this.form.value,
        });
    }
}
